import formBaseMixin from '../../../components/form/form-base-mixin.js'

export const locationTariffMixin = {
  mixins: [formBaseMixin],
  /**
   * @override
   */
  title () {
    return this.formTitle
  },
  data () {
    return {
      fields: {}
    }
  },
  computed: {
    /**
     * @override
     */
    formTitle () {
      if (this.itemId) {
        return `Расчет тарифа ${this.item.geo_object}`
      }
      return ''
    }
  },
  methods: {
    /**
     * @override
     */
    update () {
      if (this.item) {
        this.fields = Object.assign({
          containers_count: 0.75,
          transport_tariff: 0
        }, this.item)
      }
    },
    /**
     * @override
     */
    onSuccess () {
      this.showOnSuccess('Расчет завершен')
      this.unFreezeFrom()
      this.onSaveForm()
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    return promises.length > 0 ? Promise.all(promises) : Promise.resolve()
  }
}
